import { render, staticRenderFns } from "./CoreDetails.vue?vue&type=template&id=1d5b2aed&scoped=true&"
import script from "./CoreDetails.vue?vue&type=script&lang=js&"
export * from "./CoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./CoreDetails.vue?vue&type=style&index=0&id=1d5b2aed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b2aed",
  null
  
)

export default component.exports